// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__1l8de","empty":"ModalGraph_empty__zm68j"};